function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H48V48H0z",
  transform: "translate(0 .5)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#F6BF00",
  d: "M10.295 25.317c0 1.738-1.407 3.149-3.144 3.149s-3.147-1.41-3.147-3.15c0-1.737 1.41-3.146 3.147-3.146 1.737 0 3.144 1.409 3.144 3.147",
  transform: "translate(0 .5) translate(12.333 7.333)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A171B",
  d: "M4.91 6.956c-.55 0-1-.448-1-.999 0-.55.45-.997 1-.997h8.504c.55 0 .998.447.998.997 0 .551-.448.999-.998.999H4.91zm12.245 0c-.55 0-1-.448-1-.999 0-.55.45-.997 1-.997h.765c.55 0 .998.447.998.997 0 .551-.449.999-.998.999h-.765zM4.91 11.751c-.55 0-1-.448-1-.999 0-.55.45-.997 1-.997h8.504c.55 0 .998.447.998.997s-.448.999-.998.999H4.91zm12.245 0c-.55 0-1-.448-1-.999 0-.55.45-.997 1-.997h.765c.55 0 .998.447.998.997s-.449.999-.998.999h-.765zM4.91 16.545c-.55 0-1-.448-1-.998s.45-.998 1-.998h8.504c.55 0 .998.448.998.998s-.448.998-.998.998H4.91zm12.245 0c-.55 0-1-.448-1-.998s.45-.998 1-.998h.765c.55 0 .998.448.998.998s-.449.998-.998.998h-.765zM3.274 2.711c-.678 0-1.23.551-1.23 1.228v25.522c0 .677.552 1.228 1.23 1.228h16.284c.676 0 1.226-.551 1.226-1.228V3.94c0-.677-.55-1.228-1.226-1.228H3.274zm0 30.022C1.468 32.733 0 31.265 0 29.461V3.94C0 2.135 1.468.667 3.274.667h16.284c1.804 0 3.27 1.468 3.27 3.272v25.522c0 1.804-1.466 3.272-3.27 3.272H3.274z",
  transform: "translate(0 .5) translate(12.333 7.333)"
})));

var SvgIconContract = function SvgIconContract(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconContract, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_contract.d78b51dd.svg";
export { ForwardRef as ReactComponent };